const routes = {
    name: 'Product',
    icon: 'mdi-cube-outline',
    path: '/reports/timhortons/labor/',
    children: [
      {
        path: '/reports/timhortons/product/productMixDrillDown',
        name: 'Product Mix',
        component: () => import('../../standard/product/ProductMix.vue'),
        permissions: ['thProductMix'],
      },
    ]
  };

  export default routes;